export const toggleAccordionEvent = 'toggle-accordion';
